"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateInt = void 0;
var dateInt;
(function (dateInt) {
    dateInt[dateInt["SUN"] = 0] = "SUN";
    dateInt[dateInt["MON"] = 1] = "MON";
    dateInt[dateInt["TUE"] = 2] = "TUE";
    dateInt[dateInt["WED"] = 3] = "WED";
    dateInt[dateInt["THUR"] = 4] = "THUR";
    dateInt[dateInt["FRI"] = 5] = "FRI";
    dateInt[dateInt["SAT"] = 6] = "SAT";
})(dateInt || (exports.dateInt = dateInt = {}));
exports.default = dateInt;
